import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Auth_Provider_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_AUTHPRVD_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    AUTHPRVD_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    AUTHPRVD_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SORT:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sort', columnResourceName: 'colSort', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CLASS:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Class', columnResourceName: 'colClass', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    REQUIRES_USER_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'REQUIRES USER  NAME', columnResourceName: 'colREQUIRES_USER_NAME', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    REQUIRES_PASSWORD:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'REQUIRESPASSWORD', columnResourceName: 'colREQUIRES_PASSWORD', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    AUTH_KEY:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Key', columnResourceName: 'colKey', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    AUTH_SECRET:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Secret', columnResourceName: 'colSecret', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    AUTH_REQUEST_TOKEN_URL:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Token URL', columnResourceName: 'colToken_URL', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    AUTH_REQUEST_CALLBACK_URL:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Callback URL', columnResourceName: 'colCallback_URL', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    CREATED_DT:       {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Created Date', columnResourceName: 'colCreated_Date', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}},
    MODIFIED_DT:    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Modified Date', columnResourceName: 'colModified_Date', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}},
    MODIFIED_BY:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Modified By', columnResourceName: 'colModified_By', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}}
}

var AuthProviderSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_AUTHPRVD_ID',
        id_ui: 'AUTHPRVD_ID',
        name:  'AUTHPRVD_NAME'},

    searchProviderFields: vUI_Auth_Provider_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Authprvd_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var AuthProviderSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "AuthPrvdSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'AUTHPRVD_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'AUTHPRVD_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'AUTHPRVD_ID','AUTHPRVD_NAME','REQUIRES_USER_NAME','REQUIRES_PASSWORD','CREATED_DT'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: AuthProviderSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var AuthProviderSearch: ISearch = {
    searchName: "Find AuthProvider",
    renderOptions: { ui5ResourceId: "AuthProviderSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [AuthProviderSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("AuthProviderBO", "AuthProvider", AuthProviderSearch, "Auth Provider Search")

export {AuthProviderSearch}